// Nine Lives '84 - simulation types.

/** An axis-aligned box with its origin at the bottom-left, in world units. */
export interface Box {
  x: number;
  y: number;
  w: number;
  h: number;
}

export type PlatformKind =
  | 'can'
  | 'fence'
  | 'line'
  | 'sill'
  | 'floor'
  | 'furniture'
  | 'shelf'
  | 'cheese'
  | 'heart'
  | 'ledge';

/** Something the cat can stand on. One-way platforms only stop a fall. */
export interface Platform extends Box {
  oneWay: boolean;
  /** What it is, for the views. */
  kind: PlatformKind;
}

/** A moving body resolved against platforms and the world edges. */
export interface Body extends Box {
  vx: number;
  vy: number;
  onGround: boolean;
  /** The platform currently under the body, if any. */
  ground: Platform | null;
}

export type KnockedBy = 'mouse' | 'junk' | 'rival' | 'broom' | 'spider' | 'cage' | 'eel' | 'brother';

export type RoomKind = 'cheese' | 'bookshelf' | 'birdcage' | 'dogs' | 'fishbowl' | 'felicia';

/** How a room can end Tabs' life. */
export type Fatal = 'dog' | 'drowned';

export type GameEvent =
  | { kind: 'jump' }
  | { kind: 'land' }
  | { kind: 'knocked'; by: KnockedBy }
  | { kind: 'caught' }
  | { kind: 'drowned' }
  | { kind: 'respawn' }
  | { kind: 'windowOpen' }
  | { kind: 'enterWindow'; window: number }
  | { kind: 'roomStart'; room: RoomKind }
  | { kind: 'pawprint' }
  | { kind: 'sweep' }
  | { kind: 'mouseCaught'; have: number; need: number }
  | { kind: 'crawl' }
  | { kind: 'fernDown'; have: number; need: number }
  | { kind: 'nudge'; have: number; need: number }
  | { kind: 'cageBroke' }
  | { kind: 'birdCaught' }
  | { kind: 'growl' }
  | { kind: 'dogWoke' }
  | { kind: 'drink' }
  | { kind: 'bowlEmpty'; have: number; need: number }
  | { kind: 'refill' }
  | { kind: 'dive' }
  | { kind: 'surface' }
  | { kind: 'climbOut' }
  | { kind: 'fishEaten'; have: number; need: number }
  | { kind: 'shock' }
  | { kind: 'felicia' }
  | { kind: 'heartBroken' }
  | { kind: 'heartMended' }
  | { kind: 'gift'; held: number }
  | { kind: 'bribe' }
  | { kind: 'fallOut' }
  | { kind: 'kiss'; level: number; lives: number; bonus: number }
  | { kind: 'shooed' }
  | { kind: 'leftRoom' }
  | { kind: 'roomDone'; bonus: number }
  | { kind: 'gameOver' };

export enum Difficulty {
  KITTEN = 0,
  HOUSE_CAT = 1,
  TOMCAT = 2,
  ALLEY_CAT = 3,
}

export const DIFFICULTY_NAMES = ['Kitten', 'House Cat', 'Tomcat', 'Stray'];
